import { getRiskBandsMode } from "@/features/branding";
import { haloFacadesApi } from "@/store/services/facades/endpoints/halo";
import { simpleFacadesApi } from "@/store/services/facades/endpoints/simple";
import { FacadesBatchPostRequest } from "@/store/services/facades/types";
import { PortfolioRegionType } from "@/tools/aggregate/portfolio-export/types";

export const getPortfolioExportPostAction = (request: FacadesBatchPostRequest, regionType?: PortfolioRegionType) => {
  // Global needs comprehensive due to HKMA's keys not having simple.
  // We can probably just replace this wholesale, but this is a good
  // way to test it + have cover in case of issues (Global is new,
  // so bugs expected).
  const mode = regionType === "global" ? "comprehensive" : getRiskBandsMode();
  switch (mode) {
    case "abc":
      throw new Error("ABC Portfolio Analysis not implemented.");

    case "halo":
      return haloFacadesApi.endpoints.postHaloBatch.initiate(request);

    case "simple":
      return simpleFacadesApi.endpoints.postSimpleStructuralBatch.initiate(request);

    case "comprehensive":
      // Rename to structuralFacadesApi
      return simpleFacadesApi.endpoints.postComprehensiveStructuralBatch.initiate(request);
  }
};
